import React from 'react';

import { Provider as AnalyticsProvider } from './AnalyticsContext';
import { Provider as AnchorCardProvider } from './AnchorCardContext';
import { Provider as ApplicationSettingsProvider } from './ApplicationSettingsContext';
import { Provider as BannerProvider } from './BannerContext';
import { Provider as BreadcrumbProvider } from './BreadcrumbContext';
import { Provider as CompareProvider } from './CompareContext';
import { Provider as DiscoveryProvider } from './DiscoveryContext';
import { Provider as EnergyDrawerContext } from './EnergyDrawerContext';
import { Provider as FacetProvider } from './FacetContext';
import { Provider as FilterSuggestionsProvider } from './FilterSuggestionsContext';
import { Provider as ProductProvider } from './ProductContext';
import { Provider as RequestProvider } from './RequestContext';
import { Provider as SearchProvider } from './SearchContext';
import { Provider as SocialProofProvider } from './SocialProofContext';

export const RootContext = ({ children, providerData }) => {
  const {
    banners,
    breadcrumbs,
    discovery,
    facets,
    filterSuggestions,
    pageCorrelationId,
    products,
    search,
  } = JSON.parse(providerData);

  return (
    <ApplicationSettingsProvider>
      <RequestProvider pageCorrelationId={pageCorrelationId}>
        <ProductProvider products={products}>
          <DiscoveryProvider discovery={discovery}>
            <SocialProofProvider>
              <FacetProvider facets={facets}>
                <FilterSuggestionsProvider
                  filterSuggestions={filterSuggestions}
                >
                  <SearchProvider search={search}>
                    <CompareProvider>
                      <BreadcrumbProvider breadcrumbs={breadcrumbs}>
                        <AnalyticsProvider>
                          <AnchorCardProvider>
                            <BannerProvider banners={banners}>
                              <EnergyDrawerContext>
                                {children}
                              </EnergyDrawerContext>
                            </BannerProvider>
                          </AnchorCardProvider>
                        </AnalyticsProvider>
                      </BreadcrumbProvider>
                    </CompareProvider>
                  </SearchProvider>
                </FilterSuggestionsProvider>
              </FacetProvider>
            </SocialProofProvider>
          </DiscoveryProvider>
        </ProductProvider>
      </RequestProvider>
    </ApplicationSettingsProvider>
  );
};
